import { actRequest } from "./request/request"
import { RESP } from "./request"

export type AvatarDto = {
    type: string | null
    id: string
    url: string | null
}

export type CheckUserResultData = {
    userId: string
    sdkId: string
    nickname: string | null
    level: number | null
    avatar: AvatarDto | null
    lastOnlineTs: number | null
}

/** SDK 登录：POST /account/checkuser */
export const requestCheckUser = async (sdkId: string, token: string) => {
    return actRequest.post<
        null,
        RESP<{
            results: CheckUserResultData
            token: string
            cache: boolean
        }>
    >("/account/checkuser", { sdkId, token, channel: "official" })
}

/** Cookie 续期 / 取当前用户信息：GET /account/checkuser */
export const requestGetCurrentUser = async () => {
    return actRequest.get<
        null,
        RESP<{
            results: CheckUserResultData
        }>
    >("/account/checkuser")
}

/** 登出：POST /account/logout */
export const requestLogout = async () => {
    return actRequest.post<null, RESP<Record<string, never>>>(
        "/account/logout",
    )
}
